import { render } from "./LeaveThanks.vue?vue&type=template&id=b3d855f6&scoped=true&bindings={\"answer\":\"props\",\"answer_comment\":\"props\",\"csrf\":\"setup\",\"state\":\"setup\",\"FormSelectField\":\"setup\",\"confirm\":\"setup\"}"
import script from "./LeaveThanks.vue?vue&type=script&lang=ts"
export * from "./LeaveThanks.vue?vue&type=script&lang=ts"

import "./LeaveThanks.vue?vue&type=style&index=0&id=b3d855f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b3d855f6"

export default script